import type { Task } from './types'

/**
 * タスク同士の前提関係（`taskRequirements`）から派生する情報。
 * → doc/task-board/master.md#カッパコンテナの印
 *
 * React にも DOM にも依存しないので単体で検証できる（`npm run test:variants`）。
 */

/**
 * カッパコンテナ（Collector）に要るタスクの集合。
 *
 * `kappaRequired` が立っているタスクから **前提を再帰的に辿って**作る。
 * フラグだけを見ないのは、上流が終端のタスクにしか印を付けなくなっても
 * チェーンが欠けないようにするため。
 *
 * いまの実データでは 13件（Collector 本体＋5本のチェーン）で、
 * `kappaRequired` の13件と完全に一致する。
 */
export function kappaChain(tasks: Task[]): Set<string> {
  const byId = new Map(tasks.map((t) => [t.id, t]))
  const need = new Set<string>()
  const stack: string[] = []

  for (const t of tasks) {
    if (!t.kappaRequired) continue
    need.add(t.id)
    stack.push(t.id)
  }

  while (stack.length) {
    const task = byId.get(stack.pop()!)
    if (!task) continue
    for (const id of task.taskRequirements) {
      if (need.has(id) || !byId.has(id)) continue
      need.add(id)
      stack.push(id)
    }
  }

  return need
}

/**
 * 前提タスクの名前。**先にこれを終わらせないと受けられない**もの。
 *
 * 上流が持っているのは 517件中221件ぶんで、残りはトレーダーの LL とプレイヤーレベルだけで
 * 開く（`Debut` などは本当に前提タスクを持たない）。引けないIDは黙って飛ばす。
 */
export function prerequisiteNames(task: Task, byId: Map<string, Task>): string[] {
  const out: string[] = []
  for (const id of task.taskRequirements) {
    const name = byId.get(id)?.name
    if (name && !out.includes(name)) out.push(name)
  }
  return out
}
